import { Link } from "react-router-dom";

import logo from "../assets/logo1.png";
import "../css/components/footer.css";

const footerAboutLinks = [
  {
    display: "Who We Are",
    path: "/about",
  },
  {
    display: "Contact",
    path: "/contact",
  },
];

const footerRecommendLinks = [
  {
    display: "YouTube Channels",
    path: "/youtube",
  },
  {
    display: "Facebook Pages",
    path: "/facebook",
  },
  {
    display: "Movie Critics",
    path: "/critics",
  },
];

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-group">
          <div className="footer-title">About Us</div>
          <div className="footer-content">
            {footerAboutLinks.map((item, index) => (
              <p key={index}>
                <Link
                  style={{ color: "white", textDecoration: "none" }}
                  to={item.path}
                  onClick={(e) => e.preventDefault()}

                >
                  {item.display}
                </Link>
              </p>
            ))}
          </div>
        </div>

        <div className="footer-group">
          <div className="footer-title">Recommend</div>
          <div className="footer-content">
            {footerRecommendLinks.map((item, index) => (
              <p key={index}>
                <Link
                  style={{ color: "white", textDecoration: "none" }}
                  to={item.path}
                  onClick={(e) => e.preventDefault()}
                >
                  {item.display}
                </Link>
              </p>
            ))}
          </div>
        </div>

        <div className="footer-group footer_about include_logo">
          <p>
            <Link to="/">
              <img src={logo} className="footer-logo" alt="felice" />
            </Link>
          </p>
          <p style={{ color: "white" }}>Just a blog about movies @@.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
